<template>
	<section class="section ht-profile-user-transfer">
		<div class="columns is-centered">
			<div class="column is-7-widescreen is-6-fullhd">
				<div v-if="$route.params.type == 'simplepay'" class="container">
					<h2 class="title">{{ t$('Transaction successful') }}</h2>
					<p>{{ $t('Thank you for your purchase.') }}"</p>
					<b-button @click="closeWindow" type="is-default">{{ $t('close') }}</b-button>
				</div>
				<div v-if="$route.params.type == 'cash'" class="container">
					<h2 class="title">{{ $t('Thank you') }}</h2>
					<h2>
						{{ $t('To collect your order, please arrange an appointment with us.') }}
					</h2>
					<span class="label">{{ $t('Order total') }}: {{ $route.query.price | fmtCurrency('HUF') }}</span>
				</div>
				<div v-if="$route.params.type == 'transfer'" class="container">
					<h2 class="title">{{ $t('Transfer') }}</h2>
					<p>{{ $t("You've chosen to pay with transfer.") }}</p>
					<p v-if="this.user.country_code == 'HU'">
						{{ $t('Please transfer the Order Total to the following bank account:') }}
					</p>
					<p v-else>
						<span class="label">We will send you an invoice for bank transfer soon.</span>
					</p>
					<table class="table">
						<tbody>
							<tr>
								<td>
									<span class="label">{{ $t('Company') }}</span>
								</td>
								<td>HT Auction Kft.</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Address') }}</span>
								</td>
								<td>H-1066 Budapest, Zichy Jenő utca 1.</td>
							</tr>
							<tr v-if="false">
								<td>
									<span class="label">{{ $t('Account number (IBAN)') }}</span>
								</td>
								<td>
									HU57 1210 0011 1781 6106 0000 0000
								</td>
							</tr>
							<tr v-if="this.user.country_code == 'HU'">
								<td>
									<span class="label">{{ $t('Account number (GIRO)') }}</span>
								</td>
								<td>
									12100011-17816106
								</td>
							</tr>
							<tr v-if="this.user.country_code == 'HU'">
								<td>
									<span class="label">{{ $t('SWIFT code') }}</span>
								</td>
								<td>
									UBRTHUHB
								</td>
							</tr>
							<tr v-if="this.user.country_code == 'HU'">
								<td>
									<span class="label">{{ $t('Bank name') }}</span>
								</td>
								<td>
									GRÁNIT BANK
								</td>
							</tr>
							<tr v-if="this.user.country_code == 'HU'">
								<td>
									<span class="label">{{ $t('Bank country') }}</span>
								</td>
								<td>{{ $t('Hungary') }}</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Reference') }}</span>
								</td>
								<td>{{ $route.query.order_id }}</td>
							</tr>
							<tr>
								<td>
									<span class="label">{{ $t('Amount') }}</span>
								</td>
								<td>{{ $route.query.price | fmtCurrency('HUF') }}</td>
							</tr>
						</tbody>
					</table>
					<!-- <b-button @click="$router.push('/profile/mybids')" type="is-default">Vissza</b-button> -->
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	components: {},
	data() {
		return {
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
			user: {},
			preferences: {},
		}
	},
	props: {},
	mounted() {
		console.log('ROUTER', this.$route.params.order_id)
		this.getUser()
	},
	methods: {
		closeWindow() {
			window.close()
		},
		getUser() {
			var _this = this
			setTimeout(function () {
				_this.$http.get('/users').then((response) => {
					console.log('Profile', response.data)
					_this.user = response.data.user
					_this.preferences = response.data.user.UserPreference
					console.log('___________ preferences:', _this.preferences)
					if (!_this.preferences.name) {
						_this.preferences.name = _this.user.bidder_name
					}
					if (!_this.preferences.currency) {
						_this.preferences.currency = 'HUF'
					}
					if (!_this.preferences.language) {
						_this.preferences.language = 'HU'
					}
					_this.preferences.bidder_name = _this.preferences.name
					_this.loading = false
				})
			}, 100)
		},
	},
	watch: {},
}
</script>
<style lang="css">
.ht-profile-user-pay-type {
	height: 50vh;
	padding-top: 40px;
	text-align: center;
}
.pay-success {
	color: green;
}
.pay-failed {
	color: red;
}
</style>
